let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fSrP9")).then(() => parcelRequire('aYT5g'));